import { render, staticRenderFns } from "./NewsAuthorCell.vue?vue&type=template&id=2bd5a710&scoped=true&"
import script from "./NewsAuthorCell.vue?vue&type=script&lang=js&"
export * from "./NewsAuthorCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5a710",
  null
  
)

export default component.exports